import { Injectable } from '@angular/core';
import { MeetingSchedulerService } from '@self-serve/interface/calendar.abstract';
import { Employee } from '@models/employee/employee.model';

@Injectable()
export class FakeCalendarService implements MeetingSchedulerService {
    async bookMeeting(employee: Employee): Promise<Date> {
        return new Date();
    }
}
